<template>
	<div>
		<InputText
			v-model="name"
			:name="$t('C_createaspot_title_B')"
			:placeholder="$t('profileCreation_name_placeholder')"
			:label="$t('C_createaspot_title_B')"
			:error="error"
			size="s"
			@input="emit('change', name)"
		/>
	</div>
</template>

<script setup lang="ts">
	interface Props {
		error?: string
	}

	defineProps<Props>()

	const emit = defineEmits(['change'])

	const name = defineModel<string>()
</script>
